import {
    ColoursObj,
    Gutters,
    MenuButton,
    Typography,
} from '@eventr/common-storybook'
import { NavigationView } from '../../layout/NavigationView'
import { Stack } from '@mui/material'
import i18n from '../../../i18n/i18next'
import { Capacitor } from '@capacitor/core'

export default function SettingsPage() {
    const menuItems = [
        {
            path: '/account/about',
            label: 'account.about',
        },
        {
            path: '/account/themes',
            label: 'account.themes',
        },
        {
            path: '/account/languages',
            label: 'account.language',
        },
        {
            path: '/account/time',
            label: 'account.time',
        },
    ]

    const localNotificationMenuItem = {
        path: '/account/local-notifications',
        label: 'account.local-notifications',
    }

    const menuItemsToDisplay = [...menuItems, localNotificationMenuItem]

    return (
        <NavigationView
            navigationBarTitle={i18n.t('account.settings')}
            backButtonAction={() => {
                window.pushPath('/account')
            }}
            usePageTransition
        >
            <Gutters>
                <Stack gap="8px">
                    {menuItemsToDisplay.map((item) => (
                        <MenuButton
                            key={item.path}
                            onClick={() => {
                                window.pushPath(item.path)
                            }}
                            endIcon={'Chevron_Right'}
                            endIconColour={ColoursObj.font.primary}
                            style={{
                                background: ColoursObj.backgrounds.secondary,
                            }}
                        >
                            <Typography
                                variant="bodyRegular"
                                color={ColoursObj.font.primary}
                            >
                                {i18n.t(item.label)}
                            </Typography>
                        </MenuButton>
                    ))}
                </Stack>
            </Gutters>
        </NavigationView>
    )
}
